










































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { RequestMessage, DataTablePagination } from '@/types/_'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import { maskDate } from '@/utils/common'
import moment from 'moment'

@Component
export default class ViewFinanceiroDownloadNotas extends Vue {
  modalDownloadNotaFiscal: boolean = false
  modalDownloadNota: boolean = false
  loadDownloadNotasList: boolean = false

  // Polling: enquanto houver lote "Em andamento", recarrega a lista periodicamente para o
  // botão de download habilitar sozinho quando o worker concluir (sem reload manual).
  // O intervalo cresce a cada rodada (8s -> 60s) para acompanhar lotes demorados sem
  // martelar a API, e o teto por tempo total substitui o antigo teto por tentativas, que
  // encerrava o polling em ~2 min e deixava o botão travado até o F5.
  private pollHandle: number | null = null
  private pollInicioMs: number = 0
  private pollIntervaloAtualMs: number = 8000
  private readonly pollIntervaloMinMs: number = 8000
  private readonly pollIntervaloMaxMs: number = 60000
  private readonly pollDuracaoMaxMs: number = 30 * 60 * 1000

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get cargaRemuneracaoLength() {
    return Math.ceil((this.getFinanceiroStore.totalItemsDownloadNotasFiscais || 0) / this.getFinanceiroStore.qtdPorPagina)
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  get headers() {
    return this.getFinanceiroStore.tabelaDownloadNotasFiscais
  }

  get itensImportadosRecebimento() {
    return this.getFinanceiroStore.itemsDownloadNotasFiscais
  }

  get showModalDownloadNota() {
    return this.modalDownloadNota
  }

  set showModalDownloadNota(value: boolean) {
    this.modalDownloadNota = value
  }

  get loadingDownloadNotasList() {
    return this.loadDownloadNotasList
  }

  set loadingDownloadNotasList(value: boolean) {
    this.loadDownloadNotasList = value
  }

  openModalFiltroDownloadNotas() {
    this.getFinanceiroStore.setModal({ name: 'filtroDownloadNotaFiscal', value: true })
  }

  // local lateral filter drawer state
  showFiltroLateral: boolean = false
  menuAnoMesReferencia: boolean = false
  filterLoading: boolean = false

  get anoMesReferencia() {
    return this.getFinanceiroStore.anoMesReferenciaDownloadNotasFiscais
  }

  set anoMesReferencia(value: string) {
    this.getFinanceiroStore.setAnoMesReferenciaDownloadNotasFiscais(value)
  }

  get situacoesDoRepasse() {
    return this.getFinanceiroStore.situacoesDoRepasseDownloadNotasFiscais
  }

  set situacoesDoRepasse(value: string) {
    this.getFinanceiroStore.setSituacoesDoRepasseDownloadNotasFiscais(value)
  }

  get situacoesList() {
    return [
      { key: 'Todos', display: 'Todos' },
      { key: 'Pendente', display: 'Pendente' },
      { key: 'Divergente', display: 'Divergente' },
      { key: 'Provisionada', display: 'Provisionada' },
      { key: 'ValidacaoPendente', display: 'Validação pendente' },
      { key: 'Validada', display: 'Validada' },
      { key: 'Paga', display: 'Paga' },
      { key: 'EnviadoParaPagamento', display: 'Enviado para pagamento' },
    ]
  }

  formatSituacao(situacao: string) {
    if (!situacao) return '-'
    const item = this.situacoesList.find(s => s.key === situacao)
    return item ? item.display : situacao
  }

  get fontePagadoraId() {
    return this.getFinanceiroStore.fontePagadoraIdDownloadNotasFiscais
  }

  set fontePagadoraId(value: string) {
    this.getFinanceiroStore.setFontePagadoraIdDownloadNotasFiscais(value)
  }

  get grupoRepasse() {
    return this.getFinanceiroStore.grupoRepasseDownloadNotasFiscais
  }

  set grupoRepasse(value: string) {
    this.getFinanceiroStore.setGrupoRepasseDownloadNotasFiscais(value)
  }

  get geradoPor() {
    return this.getFinanceiroStore.geradoPorDownloadNotasFiscais
  }

  set geradoPor(value: string) {
    this.getFinanceiroStore.setGeradoPorDownloadNotasFiscais(value)
  }

  get getFontePagadoras() {
    return this.getFinanceiroStore.fontePagadoras
  }

  get getGrupoRepasses() {
    return this.getFinanceiroStore.grupoRepasseItensAll
  }

  get getUsuariosGeradores() {
    return this.getFinanceiroStore.usuariosGeradoresDownload
  }

  async search() {
    this.filterLoading = true
    await this.applyFiltroLateral()
    this.filterLoading = false
  }

  async clear(search?: boolean) {
    this.getFinanceiroStore.setFontePagadoraIdDownloadNotasFiscais('')
    this.getFinanceiroStore.setGrupoRepasseDownloadNotasFiscais('')
    this.getFinanceiroStore.setAnoMesReferenciaDownloadNotasFiscais('')
    this.getFinanceiroStore.setSituacoesDoRepasseDownloadNotasFiscais('')
    this.getFinanceiroStore.setGeradoPorDownloadNotasFiscais('')
    if (search) await this.applyFiltroLateral()
  }

  async applyFiltroLateral() {
    this.getPagina = 1
    await this.getFinanceiroStore.getItemsDownloadNotasFiscais()
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  formatDateTime(date: string) {
    if (!date) return 'Não informado'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  formatCompetencia(anoMes: string) {
    if (!anoMes) return 'Todas'
    return moment(anoMes).format('MM/YYYY')
  }

  dataFormatada(item: any) {
    if (!item.uploadDe && !item.uploadAte) return 'Não informado'
    return `${this.formatDate(item.uploadDe)} - ${this.formatDate(item.uploadAte)}`
  }

  getTableRowClasses(item: any) {
    const classes: string[] = []

    if (item && (item.temErro || (item.status && item.status.key === 'Erro'))) {
      classes.push('backoffice-list-table-row__urgencia')
    }

    return classes
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getItemsDownloadNotasFiscais()
    EventBus.$emit('clearLoadingRequest')
  }

  // Só registra a ordenação. NÃO refaz a busca: o v-data-table emite este evento já no
  // created, o que disparava um segundo GET concorrente com o do init() - e a resposta que
  // chegasse por último vencia, podendo reverter o lote de "Concluído" para "Em andamento".
  // A API também não ordena por parâmetro (ORDER BY nfl.CreatedOn DESC é fixo).
  updatePagination(pagination: DataTablePagination) {
    let param = ''
    if (pagination.sortBy) {
      param = pagination.descending ? `${pagination.sortBy}Desc` : `${pagination.sortBy}Asc`
    }
    this.getFinanceiroStore.setSortBy(param)
  }

  async init() {
    await this.getFinanceiroStore.getFontePagadoraAll()
    await this.getFinanceiroStore.getGrupoRepasseAll()
    await this.getFinanceiroStore.getUsuariosGeradoresDownload()
    await this.getFinanceiroStore.getItemsDownloadNotasFiscais()
    this.verificarPolling()
  }

  async atualizarLista() {
    this.loadingDownloadNotasList = true
    await this.getFinanceiroStore.getItemsDownloadNotasFiscais()
    this.loadingDownloadNotasList = false
    this.verificarPolling()
  }

  podeBaixar(item: any): boolean {
    if (!item || !item.urlSas) return false
    const acoes = item.acoes || {}
    // A chave do dicionário vem em PascalCase da API (DictionaryKeyPolicy não é configurado
    // no Startup); o status.key é o mesmo critério e serve de fallback.
    const permitido = acoes.PodeFazerDownload !== undefined
      ? acoes.PodeFazerDownload
      : (item.status && item.status.key === 'Concluido')
    return !!permitido
  }

  @Watch('itensImportadosRecebimento')
  onItensChange() {
    this.verificarPolling()
  }

  temLoteEmAndamento(): boolean {
    return (this.itensImportadosRecebimento || []).some((i: any) => i && i.status && i.status.key === 'EmAndamento')
  }

  verificarPolling() {
    if (this.temLoteEmAndamento()) {
      this.iniciarPolling()
    } else {
      this.pararPolling()
    }
  }

  iniciarPolling(reiniciarJanela: boolean = false) {
    if (reiniciarJanela) this.pararPolling()
    if (this.pollHandle !== null) return
    this.pollInicioMs = Date.now()
    this.pollIntervaloAtualMs = this.pollIntervaloMinMs
    this.agendarProximoPoll()
  }

  private agendarProximoPoll() {
    this.pollHandle = window.setTimeout(async () => {
      this.pollHandle = null

      if (!this.temLoteEmAndamento()) return
      if (Date.now() - this.pollInicioMs > this.pollDuracaoMaxMs) return

      await this.getFinanceiroStore.getItemsDownloadNotasFiscais()

      if (!this.temLoteEmAndamento()) return
      this.pollIntervaloAtualMs = Math.min(this.pollIntervaloAtualMs * 1.5, this.pollIntervaloMaxMs)
      this.agendarProximoPoll()
    }, this.pollIntervaloAtualMs)
  }

  pararPolling() {
    if (this.pollHandle !== null) {
      window.clearTimeout(this.pollHandle)
      this.pollHandle = null
    }
  }

  // Voltar para a aba é o momento em que o usuário espera ver o estado atual: refaz a busca
  // e reabre a janela de polling, mesmo que ela já tenha se esgotado.
  private async onVisibilidadeAlterada() {
    if (document.hidden) return
    await this.getFinanceiroStore.getItemsDownloadNotasFiscais()
    if (this.temLoteEmAndamento()) this.iniciarPolling(true)
  }

  private onLoteGerado() {
    this.iniciarPolling(true)
  }

  async mounted() {
    document.addEventListener('visibilitychange', this.onVisibilidadeAlterada)
    EventBus.$on('notaFiscalLoteGerado', this.onLoteGerado)
    await this.init()
  }

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilidadeAlterada)
    EventBus.$off('notaFiscalLoteGerado', this.onLoteGerado)
    this.pararPolling()
    this.clear(false)
  }
}
